import { useLayoutEffect } from 'react';

interface PlaywireAdSlotProps {
    className?: string;
    divId: string;
    divIdSufix?: string;
    type: string;
}

const PlaywireAdSlot: React.FC<PlaywireAdSlotProps> = props => {
    const { type, divId, divIdSufix = '', className } = props;

    const selectorId = divIdSufix ? `${divId}-${divIdSufix}` : divId;

    const addAd = () => {
        if (!window.ramp) return;
        const payload = { selectorId, type };

        console.log('[PlaywireAdSlot] Pushing Playwire ad with payload:', payload);
        window.ramp.que?.push(() => {
            window.ramp.spaAddAds([payload]);
        });
    };

    useLayoutEffect(() => {
        addAd();
    }, [selectorId]);

    return <div className={className} id={selectorId} />;
};

export default PlaywireAdSlot;
